module.exports = __webpack_public_path__ + "static/Boy@2x.6bcf69a4.png";